"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Step = /** @class */ (function () {
    function Step(node, x, top, bottom) {
        this.Node = node;
        this.X = x;
        this.Top = top;
        this.Bottom = bottom;
    }
    Step.prototype.ChangeTop = function (newTop) {
        return new Step(this.Node, this.X, newTop, this.Bottom);
    };
    Step.prototype.ChangeBottom = function (newBottom) {
        return new Step(this.Node, this.X, this.Top, newBottom);
    };
    Step.prototype.ChangeOwner = function (newNode, newX) {
        return new Step(newNode, newX, this.Top, this.Bottom);
    };
    Step.prototype.ChangeX = function (newX) {
        return new Step(this.Node, newX, this.Top, this.Bottom);
    };
    return Step;
}());
exports.default = Step;
